import { render } from "./AutomationWizardPanel.vue?vue&type=template&id=328195dc&scoped=true"
import script from "./AutomationWizardPanel.vue?vue&type=script&lang=js"
export * from "./AutomationWizardPanel.vue?vue&type=script&lang=js"

import "./AutomationWizardPanel.vue?vue&type=style&index=0&id=328195dc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328195dc"]])

export default __exports__